import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { pageRouterOne } from '@/router/routerListOne/pageRouterOne';
import { pageRouterTwo } from '@/router/routerListOne/pageRouterTwo';
// import { pageRouterRedirect } from '@/router/routerListOne/pageRouterRedirect';
import { storage } from '@/utils/storage';
import { scBrandLogo } from '@/pages/pageListAll/pageOneSc/config';

const routes: Array<RouteRecordRaw> = [
  // ...pageRouterRedirect,
  ...pageRouterOne,
  ...pageRouterTwo,
  // 替代vue2中的'*'通配符路径
  { path: '/:pathMatch(.*)*', redirect: '/404' },
  {
    path: '/productMatchingSuccess',
    name: 'productMatchingSuccess',
    component: () => import('@/pages/productMatch/success.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/productMatchingError',
    name: 'productMatchingError',
    component: () => import('@/pages/productMatch/error.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/onlineSuccess',
    name: 'onlineSuccess',
    component: () => import('@/pages/productMatch/onlineSuccess.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/onlineError',
    name: 'onlineError',
    component: () => import('@/pages/productMatch/onlineError.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/innerTest',
    name: 'innerTest',
    component: () => import('@/pages/productMatch/innerTest.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(), // hash 模式则使用 createWebHashHistory()
  routes,
});

router.afterEach((to, from) => {
  /* 路由发生变化修改页面 title */
  if (to && to.meta && to.meta.title) document.title = String(to.meta.title);
  const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (favicon) {
    favicon.href =
      to.path.startsWith('/IFPageOneSc') || to.path.startsWith('/IFPageOneHSixtyThree')
        ? scBrandLogo
        : '/icon.png';
  }
  if (to.path === '/') {
    router.go(-1);
  }
});
router.beforeEach((to, from, next) => {
  const query = to.query;
  for (const i in query) {
    saveRouterValue(i, <string>query[i]);
  }
  // 这里调用了，会引起pinia的报错, 大致是，这里调用了接口，接口封装里面调用了pinia，而这里pinia还没有挂在到vue上 移至app.vue
  // 获取动态guide页的方法
  // const { getGuideDownUrl } = loginRegister();
  // getGuideDownUrl(true);
  next();
});
function saveRouterValue(name: string, value: string) {
  if (name) {
    if (name === 'yxToken') {
      name = 'token';
    }
    if (name === 'xdTagFlag') {
      /**短信短链埋点*/
      name = 'token';
    }
    if (name === 'token') {
      storage.setItem(name, value, null, 1);
    } else if (name === 'channelId') {
      storage.setItem(name, value, null, 1);
      storage.setItem(name, value, null, 2);
    } else {
      storage.setItem(name, value, null, 2);
    }
  }
}

export default router;
